export const getStudentGroups = applications => {
	const byStudent = new Map()
	applications.forEach(app => {
		const key = String(app?.studentId || '').trim()
		if (!key) return
		if (!byStudent.has(key)) byStudent.set(key, [])
		byStudent.get(key).push(app)
	})

	return Array.from(byStudent.entries())
		.map(([studentId, apps]) => ({
			studentId,
			studentName: apps[0]?.studentName || 'Student',
			apps: [...apps].sort((a, b) =>
				String(a?.id || '').localeCompare(String(b?.id || ''), undefined, {
					numeric: true,
				}),
			),
		}))
		.sort((a, b) => a.studentName.localeCompare(b.studentName))
}
